import { twMerge } from "tailwind-merge";
import { Button } from "@/components/Button";

export interface SaveBarProps {
  formId?: string;
  show: boolean;
  isSubmitting?: boolean;
  onCancel?: () => void;
  primaryLabel?: string;
  secondaryLabel?: string;
  className?: string;
}

export function SaveBar({
  formId,
  show,
  isSubmitting,
  onCancel,
  primaryLabel = "Save changes",
  secondaryLabel = "Cancel",
  className,
}: SaveBarProps) {
  if (!show) return null;

  return (
    <div
      className={twMerge(
        "fixed inset-x-0 bottom-0 z-40 border-t border-border-muted bg-background-surface/95 backdrop-blur supports-[backdrop-filter]:bg-background-surface/70",
        className
      )}
    >
      <div className="mx-auto flex max-w-screen-lg items-center justify-between gap-3 p-3">
        <div className="text-sm text-text-secondary">You have unsaved changes</div>
        <div className="flex gap-2">
          <Button variant="secondary" onPress={onCancel}>
            {secondaryLabel}
          </Button>
          <Button type="submit" form={formId} isDisabled={!!isSubmitting}>
            {isSubmitting ? "Saving..." : primaryLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
